import Text from "@/components/common/Typography/Text";
import ArrowLeftRightHalfIcon from "@/components/icons/ArrowLeftRightHalfIcon";
import { Card, CardProps, Col, Row, Skeleton } from "antd";
import { FC } from "react";

interface FlightDealItemSkeletonProps extends Omit<CardProps, 'type'> {
  shown?: boolean,
  styles?: any,
  isMobile?: boolean,
  type?: 'DOMESTIC' | 'INTERNATIONAL'
}

const FlightDealItemSkeleton: FC<FlightDealItemSkeletonProps> = ({ shown, type, ...props }) => {

  return (
    <Card
      hoverable
      size="small"
      {...props}
      className={`${props.className ? `${props.className} ` : ""}home__deals-flights--item skeleton`}
      style={{ cursor: "pointer" }}
      styles={{
        ...props.styles,
        body: {
          display: "flex",
          flexDirection: "column",
          ...props.styles?.body,
        },
      }}
      cover={type === 'INTERNATIONAL' && <Skeleton.Image style={{ height: "20rem", width: '100%' }} styles={{ root: { width: '100%' } }} />}
    >
      <Row style={{ minHeight: type === 'DOMESTIC' ? "14rem" : "11rem" }}>
        <Col span={24}>
          <Row>
            <Col span={24}>
              {type === 'DOMESTIC' && (<Row>
                <Skeleton
                  paragraph={false}
                  styles={{
                    title: {
                      height: '4rem',
                      width: "8rem",
                      margin: 0
                    }
                  }}
                  active
                />
              </Row>)}
              <Row
                className="home__deals-flights--item-title"
                align="middle"
                wrap={false}
                gutter={[10, 10]}
                style={{ marginTop: 5 }}
              >
                <Col>
                  <Skeleton
                    paragraph={false}
                    styles={{
                      title: {
                        height: '2.2rem',
                        width: '9rem',
                        margin: 0
                      }
                    }}
                    active
                  />
                </Col>
                <Col>
                  <Text>
                    <ArrowLeftRightHalfIcon />
                  </Text>
                </Col>
                <Col>
                  <Skeleton
                    paragraph={false}
                    styles={{
                      title: {
                        height: '2.2rem',
                        width: '9rem',
                        margin: 0
                      }
                    }}
                    active
                  />
                </Col>
              </Row>
              <Row style={{ marginTop: 5 }} className="home__deals-flights--item-date">
                <Skeleton
                  paragraph={false}
                  styles={{
                    title: {
                      height: '2.2rem',
                      width: '100%',
                      margin: 0
                    }
                  }}
                  active
                />
              </Row>
            </Col>
          </Row>
        </Col>
        <Col span={24} style={{ height: 'fit-content', alignSelf: 'end' }}>
          <Row justify="end">
            <Col>
              <Skeleton
                paragraph={false}
                styles={{
                  title: {
                    height: '2.2rem',
                    width: '10.3rem',
                    margin: 0
                  }
                }}
                active
              />
            </Col>
          </Row>
          <Row style={{ marginTop: 5 }} align="middle" gutter={[10, 10]} justify="end">
            <Col>
              <Skeleton
                paragraph={false}
                styles={{
                  title: {
                    height: '2.2rem',
                    width: '9.3rem',
                    margin: 0
                  }
                }}
                active
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </Card>
  )
};

export default FlightDealItemSkeleton